import ErrorPage from "@/components/error/ErrorPage";

const UnauthorizedPage: React.FC = () => {
  return <ErrorPage statusCode={401} title='권한이 없습니다' message='해당 페이지에 접근할 수 있는 권한이 없습니다.' />;
};

export default UnauthorizedPage;
